import React from 'react';
import PropTypes from 'prop-types';

// App components.
import Badge from 'app/client/components/Badge';

const resolveDisplay = (name, expired) => {
  if (name === 'paid') return { color: 'success', icon: 'check' };
  if (expired) return { color: 'warning', icon: 'clock' };
  return { color: 'regular', icon: 'circle-info' };
};

const FinanceStatus = ({ name, title, expired = false }) => {
  const { color, icon } = resolveDisplay(name.toLowerCase(), expired);
  return (
    <Badge color={color} icon={icon}>
      {title}
    </Badge>
  );
};

FinanceStatus.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  expired: PropTypes.bool,
};

export default FinanceStatus;
